import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tinymce"
export default class extends Controller {
  static values = {
    profile: { type: String, default: 'default' },
    config: Object
  }

  connect() {
    TinyMCERails.configuration.default = this.configValue;
    TinyMCERails.initialize()
  }

  disconnect() {
    tinymce.remove();
  }
}
